import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import useUserAuth from '../hooks/useUserAuth';

const Dashboard = () => {
  // useUserAuth();
  return (
    <Box as="section" bg="gray.500" minH="100vh">
      <Sidebar
        display={{
          base: 'none',
          md: 'unset',
        }}
      />
      <Box
        ml={{
          base: 0,
          md: 64,
        }}
        transition=".3s ease"
      >
        <Header />
        <Box as="main">
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};
export default Dashboard;
